import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;

@media all and (max-width:${variables.tabletL}) {}
`;